export const BASE_URL = 'https://iuzpeijktl.execute-api.us-west-1.amazonaws.com/dev'
